import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  Modal,
  ModalHeader
} from "reactstrap"
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import paginationFactory from 'react-bootstrap-table2-paginator'
import FormVendedor from './formVendedores'
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import useToggle from "../../../lib/useToggle"
import Loading from 'lib/loading'
import ReactSelect from 'react-select'

const Vendedores = () => {

  const CONTROL_HEIGHT = 38;

  const selectStyles = {
    control: (base) => ({
      ...base,
      minHeight: CONTROL_HEIGHT,
      height: CONTROL_HEIGHT,
    }),
    valueContainer: (base) => ({
      ...base,
      height: CONTROL_HEIGHT,
      padding: "0 12px",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: CONTROL_HEIGHT,
    }),
    placeholder: (base) => ({
      ...base,
      margin: 0,
    }),
    singleValue: (base) => ({
      ...base,
      margin: 0,
    }),
  };

  const colunas = [
    {
      dataField: 'vendedor_id',
      text: 'Código'
    },
    {
      dataField: 'vendedor',
      text: 'Vendedor'
    },
    {
      dataField: 'ativo',
      text: 'ativo',
      formatter: (cellContent, row) => {
        if (row.ativo === 'S' ) {
          return <div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">Sim</span></div>
        }else{
          return <div className="timeline-heading"><span className="badge badge-danger badge-pill m-0 aberto">Não</span></div>
        }
      }
    },
    {
      dataField: 'acesso_adm',
      text: 'Administrador',
      formatter: (cellContent, row) => {
        if (row.acesso_adm === 'S' ) {
          return <div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">Sim</span></div>
        }else{
          return <div className="timeline-heading"><span className="badge badge-danger badge-pill m-0 aberto">Não</span></div>
        }
      }
    },
    {
      dataField : 'cpf',
      text      : 'cpf'
    },
    {
      dataField : 'loja',
      text      : 'loja'
    }
  ]

  const { SearchBar }                     = Search
  const [modal, setModal]                 = useToggle()
  const [loading, setLoading]             = useState(true)
  const [vendedor_id, setVendedor_id]     = useState('')
  const [listaVendedor, setListaVendedor] = useState([])
  const [vendedorAtivo, setVendedorAtivo] = useState('S')

  const listaVendedores = () => {
    let lista = []
    const url = rotas.vendedor

    //filtro ativo
    const parametros = {
      ativo: vendedorAtivo
    }

    try{
      const retorno = rest.post(url, parametros);
      retorno.then(ret => {
        if (ret.success && ret.success === 'S'){
          lista = ret.lista
          for (let i = 0; i < lista.length; i++) {
            if (lista[i].filial_id === 0) {
              lista[i].loja = "TODAS AS LOJAS"
            }
          }
          setListaVendedor(lista)
        }
        setLoading(false);
      })
      return (lista)

    }catch(err){
      console.log(err);
    }
  }

  useEffect(() => {
    const load = loading;
    if (load === true) {
      listaVendedores();
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if(modal===false){
      listaVendedores()
    }
  }, [modal, vendedorAtivo]) // eslint-disable-line react-hooks/exhaustive-deps

  const abreModal = (vendedor_id) => {
    setVendedor_id(vendedor_id)
    setModal()
  }

  if (loading) {
    return ( <Loading tipo='paginas' /> )
  }else {
    return (
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <CardTitle>CADASTRO DE VENDEDORES</CardTitle>
                </CardHeader>
                <CardBody>
                  <Modal
                    size    = 'xl'
                    isOpen  = {modal}
                  >
                    <ModalHeader>Cadastro de Vendedores</ModalHeader>
                    <FormVendedor
                      fechaModal      = {setModal}
                      vendedor_id     = {vendedor_id} 
                      setVendedor_id  = {setVendedor_id} 
                    >
                    </FormVendedor>
                  </Modal>
                  <ToolkitProvider
                    search
                    keyField  = "vendedor_id"
                    data      = {listaVendedor}
                    columns   = {colunas}
                  >
                    {
                      props => (
                        <div>
                          <Container>
                            <Row className="align-items-center">
                              <Col md="3">
                                <Button
                                  outline
                                  className="m-0 w-100"
                                  color="primary"
                                  style={{ height: CONTROL_HEIGHT }}
                                  onClick={() => abreModal("")}
                                >
                                  <i className="fas fa-plus" />
                                  Cadastrar
                                </Button>
                              </Col>

                              <Col md="3">
                                <ReactSelect
                                  id="vendedor_ativo"
                                  name="vendedor_ativo"
                                  placeholder="Status do vendedor"
                                  className="m-0 w-100"
                                  styles={selectStyles}
                                  options={[
                                    { value: "S", label: "Vendedor Ativo" },
                                    { value: "N", label: "Vendedor Bloqueado" },
                                    { value: "", label: "Todos Vendedores" },
                                  ]}
                                  onChange={(e) => setVendedorAtivo(e.value)}
                                />
                              </Col>

                              <Col md="6">
                                <SearchBar
                                  className="form-control m-0 w-100"
                                  placeholder="Buscar Vendedores..."
                                  style={{ height: CONTROL_HEIGHT }}
                                  {...props.searchProps}
                                />
                              </Col>
                            </Row>

                          </Container>

                          <hr/>

                          <BootstrapTable
                            striped
                            keyField          = 'vendedor_id'
                            noDataIndication  = "Nenhum registro encontrado"
                            rowStyle          = {{ cursor: "pointer" }}
                            pagination        = {paginationFactory({
                                                  sizePerPage: 10,
                                                  hideSizePerPage: true,
                                                  hidePageListOnlyOnePage: true,
                                                  showTotal: false,
                                                })}
                            rowEvents         = {{ onDoubleClick: (e, row, rowIndex) => { abreModal(row.vendedor_id) }}}
                            {...props.baseProps}
                          />
                          <br />
                        </div>
                      )
                    }
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default Vendedores;
